/** @format */

import { Vue, Component, Watch } from 'vue-property-decorator';
import { IAntPaginationConfig } from '../../types/table';
import * as _ from 'lodash';
@Component
export default class Table extends Vue {
  // 数据是否加载中
  loading: boolean = false;

  locationPathWhenMounted = '';

  // 记录总数
  total: number = 0;

  // 每页记录数
  pageSize: number = 10;

  // 当前页码
  current: number = 1;

  // 是否显示每页记录数切换器
  showSizeChanger = true;

  // 是否显示快速跳转器
  showQuickJumper = true;

  // 每页记录切换器数量选项
  pageSizeOptions: string[] = [].concat(['10', '20', '30', '40', '50', '100', '150', '200', '300']);

  // pageSizeOptions: string[] = (process.env.NODE_ENV == 'production' ? [] : ['5']).concat(['10', '20', '30', '40'])

  // 当前过滤器
  filters: any = {};

  // 当前排序
  sorter: any = {};

  get pagination() {
    return {
      showTotal: (total: any) => `总共 ${total} 条`,
      total: this.total,
      current: this.current,
      pageSize: this.pageSize,
      size: 'small',
      pageSizeOptions: this.pageSizeOptions,
      showSizeChanger: this.showSizeChanger,
      showQuickJumper: this.showQuickJumper
    };
  }

  /**
   * 页码改变的回调，参数是改变后的页码及每页条数
   */
  handleTableChange(pagination: IAntPaginationConfig, filters: any, sorter: any) {
    let reset = true;
    const pager = { ...pagination };
    if (this.current !== pager.current) {
      reset = false;
    }
    this.current = pager.current || 1;
    this.pageSize = pager.pageSize || 10;
    this.filters = filters;
    this.sorter = sorter;
    this.fetchTableData(reset);
  }

  mounted() {
    this.locationPathWhenMounted = this.$route.path;
    // console.log('path--:', this.$route.path)
  }
  goBack() {
    this.$router.go(-1);
  }
  fetchList: any = function() {}; // 区域列表防抖请求
  /**
   * 获取表格数据
   * @description 本方法请在引用的组件内复写
   * @param reset 是否重置页码为1
   */
  fetchTableData(reset: boolean = false) {}

  @Watch('$route')
  onRouteChanged(to: any, from: any) {
    //从子页面回来了
    if (
      this.locationPathWhenMounted === to.path &&
      from.path.indexOf(this.$route.path) > -1 &&
      'fetchTableData' in this
    ) {
      this.$nextTick(() => {
        this.fetchTableData();
      });
    }
  }
}
